<app-breadcrumb></app-breadcrumb>
<section class="ma-solar-area">
        <div class="ma-anim">
                <app-solar-navbar></app-solar-navbar>
                <router-outlet></router-outlet>
        </div>
</section>